import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import Snackbar from '@material-ui/core/Snackbar'
import Typography from '@material-ui/core/Typography'
import cx from 'classnames'

const styles = (theme) => ({
  container: {
    boxShadow: 'none',
  },
  error: {
    background: theme.palette.error.main,
  },
  warning: {
    background: theme.palette.warning,
  },
  success: {
    background: theme.palette.success,
  },
  info: {
    background: theme.palette.primary.main,
  },
})

const Alert = ({ classes, alert, closeAlert }) => (
  <Snackbar
    open={alert.open}
    onClose={closeAlert}
    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    message={
      <Typography
        style={{ color: '#fff' }}
        dangerouslySetInnerHTML={{ __html: alert.message }}
      />
    }
    key={alert.message}
    autoHideDuration={3500}
    ContentProps={{
      className: cx(classes.container, {
        [classes.error]: alert.type === 'error',
        [classes.warning]: alert.type === 'warning',
        [classes.success]: alert.type === 'success',
        [classes.info]: alert.type === 'info',
      }),
    }}
  />
)

Alert.propTypes = {
  classes: PropTypes.object.isRequired,
  alert: PropTypes.shape({
    open: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    message: PropTypes.string,
  }).isRequired,
  closeAlert: PropTypes.func.isRequired,
}

export default withStyles(styles, { withTheme: true })(Alert)



// WEBPACK FOOTER //
// ./src/components/Alert.js